import { PlacementSelectorContextProvider } from 'modules/placements/context/PlacementSelectorContextProvider';
import { EmbeddedPreviewContextProvider } from './EmbeddedPreviewContextProvider';

export const EmbeddedContext = ({ children }: { children: React.ReactNode }) => (
  <PlacementSelectorContextProvider>
    <EmbeddedPreviewContextProvider>{children}</EmbeddedPreviewContextProvider>
  </PlacementSelectorContextProvider>
);
